// privacy-popup.js
import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import '@/styles/privacy-popup.css'
import store from '@/store/index'

const pick = (o, ...keys) => keys.find(k => o?.[k] != null) && o[keys.find(k => o?.[k] != null)];

export async function openPrivacyPopup(siteCode) {
  const AuthorizeToken = localStorage.getItem('AuthorizeToken');

  let title = ``;
  let bodyHtml = ``;

  try {
    const res = await fetch(process.env.VUE_APP_URL_API + `AgencyERequest/GetConsentBySiteCode?siteCode=${encodeURIComponent(siteCode)}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${AuthorizeToken}`,
        'Content-Type': 'application/json'
      }
    });

    const data = await res.json();

    store.state.AgentRenewLicense.ConsentBySiteCode = data[0];

    // รองรับหลายรูปแบบคีย์: title/Title, content/Content/html/Html, url/Url
    title = pick(data[0], 'SubjectThai', 'subjectThai') ?? title;
    bodyHtml = pick(data[0], 'ContentThai', 'contentThai') ?? bodyHtml;

    // ถ้า API ส่งเป็น text ธรรมดา ไม่ใช่ HTML → หุ้ม <p>
    if (typeof bodyHtml === 'string' && !/[<>]/.test(bodyHtml.trim())) {
      bodyHtml = `<p class="m-0">${bodyHtml}</p>`;
    }

  } catch (e) {
    // ถ้าโหลดไม่ได้ จะใช้ข้อความ fallback เดิม และโชว์แจ้งเตือนเล็กน้อย
    console.warn('GetConsentBySiteCode failed:', e);
    // ไม่เด้ง error ใหญ่ เพื่อให้ผู้ใช้ยังอ่าน/ยอมรับได้
  }

  return Swal.fire({
    title: title,
    html: bodyHtml,
    showCancelButton: false,
    confirmButtonText: 'รับทราบ',
    width: 520,                 // ใกล้เคียงภาพ
    buttonsStyling: false,      // ใช้สไตล์ custom
    customClass: {
      popup: 'pv-swal',
      title: 'pv-title',
      htmlContainer: 'pv-html',
      confirmButton: 'pv-btn btn-bla'// pv-btn-primary
    },
    backdrop: true,
    focusConfirm: true,
    icon: undefined,             // ไม่ใช้ไอคอน ให้คลีนเหมือนภาพ
    allowOutsideClick: false,
    allowEscapeKey: false,
  })
}
